import { SpeciesSurveyDataV1 } from '@omniafishing/core';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../constants/query_keys';
import { apiV1 } from '../lib/api';
import { FIVE_MINUTES_IN_MS } from '../lib/time';

export const useWaterbodySpeciesSurveyData = (args: { waterbodySlug?: string }) => {
  const { waterbodySlug } = args;

  const waterbodySpeciesSurveyDataQuery = useQuery<SpeciesSurveyDataV1 | null>({
    queryKey: QueryKeys.WATERBODIES.SPECIES_SURVEY_DATA(waterbodySlug || ''),
    queryFn: async () => {
      try {
        const response = await apiV1.waterbodySpeciesSurveyDataFetch(waterbodySlug, {
          version: 'v1',
        });
        return response.data.data;
      } catch (error) {
        console.warn('Failed to fetch species survey data:', error);
        return null;
      }
    },
    enabled: !!waterbodySlug,
    staleTime: FIVE_MINUTES_IN_MS,
  });

  return {
    waterbodySpeciesSurveyData: waterbodySpeciesSurveyDataQuery.data,
  };
};
